<template>
  <div class="bg-white p-5 pb-1 pt-4 mt-4 rounded">
    <h4 class="title-primary">Nuevos colaboradores</h4>

    <CreateStudentForm
      :empresas="empresas"
      :searcharea="searcharea"
      :urlvalidateemail="urlvalidateemail"
      :url="get"
      @student-created="handleStudentCreated"
      @form-reset="handleFormReset"
    />

    <BulkUploadStudent
      :empresas="empresas"
      :urlmassive="urlmassive"
      @upload-success="handleUploadSuccess"
      @upload-error="handleUploadError"
      @show-message="showMessage"
    />

    <!-- Modals -->
    <modal-after-create-component 
      :usuario="lastUser" 
      :tipousuario="'student'"
    ></modal-after-create-component>
    
    <modal-info-commom-component 
      v-if="showModalInfo" 
      :info="message" 
      @close="closeModalInfo"
    ></modal-info-commom-component>
  </div>
</template>

<script>
import CreateStudentForm from './CreateStudentForm.vue'
import BulkUploadStudent from './BulkUploadStudent.vue'

export default {
  name: 'CreateStudentContainer',
  
  components: {
    CreateStudentForm,
    BulkUploadStudent
  },
  
  props: {
    get: { type: String, required: true },
    headertab: { type: Array, default: () => [] },
    rol: { type: Array, default: () => [] },
    empresas: { type: Array, default: () => [] },
    searcharea: { type: String, required: true },
    searchnivel: { type: String, default: '' },
    urlvalidateemail: { type: String, required: true },
    listroutes: { type: String, default: '' },
    urlmassive: { type: String, default: '' }
  },
  
  emits: ['reload_table'],
  
  data() {
    return {
      lastUser: {},
      message: { title: '', content: '' },
      showModalInfo: false
    };
  },
  
  methods: {
    handleStudentCreated(userData) {
      this.lastUser = { ...userData };
      
      // Show success notification
      this.$swal({
        title: 'Éxito!',
        text: 'Se ha creado el colaborador correctamente.',
        icon: 'success',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#1A0054'
      });
      
      // Trigger table reload
      this.$emit('reload_table', true);
      
      // Trigger success modal
      const successBtn = document.getElementById('studentsuccesCreationBtn');
      if (successBtn) successBtn.click();
    },
    
    handleFormReset() {
      this.lastUser = {};
    },
    
    handleUploadSuccess(response) {
      this.$emit('reload_table', true);
      
      this.$swal({
        title: 'Éxito!',
        text: 'Carga masiva completada correctamente.',
        icon: 'success',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#1A0054'
      });
    },
    
    handleUploadError(error) {
      console.error('Upload error:', error);
      
      this.$swal({
        title: 'Error!',
        text: 'Hubo un error al procesar el archivo de carga masiva.',
        icon: 'error',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#dc3545'
      });
    },
    
    showMessage(messageData) {
      this.message = messageData;
      this.showModalInfo = true;
    },
    
    closeModalInfo() {
      this.showModalInfo = false;
    }
  }
}
</script>

<style scoped>
.title-primary {
  color: #1A0054;
  font-weight: bold;
}
</style>